import Button from "@/common/elements/Button";
import { INPUT_VARIANT } from "@/common/elements/InputElements/const";
import Table from "@/common/elements/Table";
import { INMATE_DETAILS_MODE } from ".";
import { Flex, Popconfirm } from "antd";
import { forwardRef, useState, useRef, useEffect } from "react";
import DocsModal, { MODE } from "./DocsModal";
import { InmateDetailsTableContainer, TableHeader } from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { setDocs } from "@/slices/docsSlice";
import {
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  StopOutlined,
} from "@ant-design/icons";
import Modal from "@/common/elements/Modal";
import { v4 as uuidV4 } from "uuid";
import dayjs from "dayjs";
import { setBookings, setDeleteAPis } from "@/slices/bookingsSlice";
import { hasCheckSecurity, isNonEmptyVariable } from "@/util/common_function";
import API_ENDPOINTS from "@/util/api";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import {
  MODULES_LIST,
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";
import api from "@/services/axios_custom";
import { setJailIncidentStore } from "@/slices/jailIncidents";
import useDialog from "@/hooks/useDialog";

const DocsTableHeaders = [
  { key: "documentType", text: "Document Type" },
  { key: "documentName", text: "Document Name" },
  { key: "documentDate", text: "Document Date" },
  { key: "author", text: "Author" },
  { key: "comments", text: "Comments" },
];

const Docs = ({
  parentKey = MODULES_LIST.BOOKINGS,
  from = MODULES_LIST.BOOKINGS,
  onSave,
  oldDocs,
}) => {
  const dispatch = useDispatch();
  const { showDialog } = useDialog();
  const innerFormRef = useRef();
  const { jailIncident } = useSelector((s) => s?.jailIncident);
  const { bookings, bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings,
  );
  const [isModalShown, setIsModalShown] = useState(false);
  const [documentEditData, setDocumentEditData] = useState(null);
  const [isConfirmModal, setIsConfirmModal] = useState(false);
  const [isLinkedDocs, setIsLinkedDocs] = useState(false);
  const [docItems, setDocItems] = useState([]);
  const [docItemsList, setDocItemsList] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [facilityLogDocs, setFacilityLogDocs] = useState([]);

  const getDocKey = (parentKey) => {
    let retVal = "";
    switch (parentKey) {
      case "bookings":
        retVal = "bookingLinkedDocuments";
        break;
      case MODULES_LIST.JAIL_INCIDENTS:
        retVal = "jailIncidentsLinkedDocuments";
        break;

      default:
        retVal = "staffLinkedDocuments";
        break;
    }

    return retVal;
  };

  let docKey = getDocKey(parentKey);

  useEffect(() => {
    if (from == MODULES_LIST.JAIL_INCIDENTS) {
      const modifiedData = jailIncident?.[docKey]?.map((bd) => {
        return {
          uuid: uuidV4(),
          ...bd,
        };
      });
      setDocItems(modifiedData);
      console.log({ jailIncident });
    } else if (from != MODULES_LIST.FACILITY_LOG) {
      const modifiedData = bookings?.[docKey]?.map((bd) => {
        return {
          uuid: uuidV4(),
          ...bd,
        };
      });
      setDocItems(modifiedData);
      console.log({ bookings });
    }
  }, [bookings, jailIncident]);

  useEffect(() => {
    console.log({ docItems });
  }, [docItems]);

  useEffect(() => {
    if (
      isNonEmptyVariable(oldDocs) &&
      oldDocs?.length > 0 &&
      from == MODULES_LIST.FACILITY_LOG
    ) {
      setFacilityLogDocs([...oldDocs]);
    }
  }, [oldDocs]);

  useEffect(() => {
    if (from == MODULES_LIST.FACILITY_LOG) {
      const modifiedData = facilityLogDocs.map((bd) => {
        return {
          uuid: uuidV4(),
          ...bd,
        };
      });
      setDocItems(modifiedData);
    }
  }, [facilityLogDocs]);

  useEffect(() => {
    if (documentEditData === null) {
      const form = innerFormRef?.current?.form;
      form?.resetFields();
      Object.keys(form.getFieldsValue())?.forEach((k) => {
        form.setFieldValue(k, "");
      });
    }
  }, [documentEditData]);

  const onAddClick = () => {
    setIsConfirmModal(true);
    setIsModalShown(true);
    setDocumentEditData(null);
  };

  const handleLinkedDoc = (value) => {
    setIsLinkedDocs(value);
    setIsConfirmModal(false);
  };

  const onRowFileClick = (val) => {
    const isPhoto = val?.originalData?.documents?.[0]?.isPhoto;
    setIsLinkedDocs(!isPhoto);
    console.log({ val });
    setDocumentEditData(() => val);
  };

  function validateFileExtension(filename) {
    // Allowed extensions
    const allowedExtensions = [
      "doc",
      "txt",
      "jpg",
      "pdf",
      "htm",
      "html",
      "xls",
      "xlsx",
      "docx",
    ];

    // Extract extension (everything after the last dot)
    const fileExtension = filename?.split(".")?.pop()?.toLowerCase();

    if (allowedExtensions?.includes(fileExtension)) {
      return true;
    } else {
      return false;
    }
  }

  const handleSubmit = () => {
    innerFormRef?.current
      ?.validateFields()
      .then((values) => {
        console.log("🚀 ~ handleSubmit ~ values:", values);
        if (
          isNonEmptyVariable(values?.documentPath) &&
          !validateFileExtension(values?.documentPath)
        ) {
          const fileExtension = values?.documentPath
            ?.split(".")
            ?.pop()
            ?.toLowerCase();
          showDialog("info", {
            title: "Link Extension Error",
            content: `Files of  type ${"*." + fileExtension} are not supported.`,
            confirmButtonText: "Ok",
          });
          return;
        }
        values = {
          ...values,
          documentDate: isNonEmptyVariable(values?.documentDate)
            ? dayjs(values?.documentDate)?.format("MM/DD/YYYY")
            : null,
        };

        const docItemsCopy = docItems || [];
        if (docItems?.length) {
          if (documentEditData !== null) {
            docItems?.forEach((di) => {
              if (di?.uuid === documentEditData?.originalData?.uuid) {
                const { fullSizePath, documentPath, ...rest } = values;
                const isPhoto = values?.documents?.isPhoto;
                const obj = {
                  ...di,
                  ...(isPhoto && {
                    photos: [
                      {
                        ...di?.photos?.[0],
                        ...rest,
                        fullSizePath,
                      },
                    ],
                  }),
                  documents: [
                    {
                      ...di?.documents?.[0],
                      ...rest,
                      documentPath,
                    },
                  ],
                };
                docItemsCopy.push(obj);
              } else {
                docItemsCopy?.push(di);
              }
            });
            if (from == MODULES_LIST.JAIL_INCIDENTS) {
              dispatch(
                setJailIncidentStore({
                  [docKey]: docItemsCopy,
                }),
              );
            } else if (from != MODULES_LIST.FACILITY_LOG) {
              dispatch(
                setBookings({
                  [docKey]: docItemsCopy,
                }),
              );
            } else {
              setFacilityLogDocs(docItemsCopy);
              onSave(docItemsCopy);
            }
          } else {
            const { fullSizePath, documentPath, ...rest } = values;
            const valuesData = {
              bookingId: null,
              documentId: null,
              photoId: null,
              documents: [
                {
                  ...rest,
                  isPhoto: !isLinkedDocs,
                  documentPath,
                },
              ],
              ...(!isLinkedDocs && {
                photos: [
                  {
                    ...rest,
                    fullSizePath,
                  },
                ],
              }),
            };
            docItemsCopy.push(valuesData);
            if (from == MODULES_LIST.JAIL_INCIDENTS) {
              dispatch(
                setJailIncidentStore({
                  [docKey]: docItemsCopy,
                }),
              );
            } else if (from != MODULES_LIST.FACILITY_LOG) {
              dispatch(
                setBookings({
                  [docKey]: [...bookings?.[docKey], ...docItemsCopy],
                }),
              );
            } else {
              setFacilityLogDocs([...facilityLogDocs, ...docItemsCopy]);
              onSave([...facilityLogDocs, ...docItemsCopy]);
            }
          }
        } else {
          const { fullSizePath, documentPath, ...rest } = values;
          const valuesData = {
            bookingId: null,
            documentId: null,
            photoId: null,
            documents: [
              {
                ...rest,
                isPhoto: !isLinkedDocs,
                documentPath,
              },
            ],
            ...(!isLinkedDocs && {
              photos: [
                {
                  ...rest,
                  fullSizePath,
                },
              ],
            }),
          };
          docItemsCopy.push(valuesData);
          if (from == MODULES_LIST.JAIL_INCIDENTS) {
            dispatch(
              setJailIncidentStore({
                [docKey]: docItemsCopy,
              }),
            );
          } else if (from != MODULES_LIST.FACILITY_LOG) {
            dispatch(
              setBookings({
                [docKey]: [...docItemsCopy],
              }),
            );
          } else {
            setFacilityLogDocs(docItemsCopy);
            onSave(docItemsCopy);
          }
        }

        console.log({ docItemsCopy });

        // setDocItems((prev) => [...prev, { id: itemlength + 1, ...values }]);
        handleCancel();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleCancel = () => {
    setIsModalShown(false);
    setIsConfirmModal(false);
    setDocumentEditData(null);
    const form = innerFormRef?.current?.form;
    form?.resetFields();
    Object.keys(form.getFieldsValue())?.forEach((k) => {
      form.setFieldValue(k, "");
    });
    setIsEdit(false);
  };

  const onDeleteClick = () => {
    let docItemsCopy = JSON.parse(JSON.stringify(docItems));
    docItemsCopy = docItemsCopy?.filter(
      (dic) => dic?.uuid !== documentEditData?.originalData?.uuid,
    );
    console.log({ documentEditData });
    if (from == MODULES_LIST.BOOKINGS) {
      dispatch(
        setBookings({
          [docKey]: docItemsCopy,
        }),
      );

      let id = "";
      let url = "";
      console.log(
        "documentEditData?.originalData",
        documentEditData?.originalData,
      );
      if (
        isNonEmptyVariable(
          documentEditData?.originalData?.staffLinkedDocumentID,
        )
      ) {
        id = documentEditData?.originalData?.staffLinkedDocumentID;
        url = API_ENDPOINTS.staff.linkedDocs.delete + id;
      } else if (
        isNonEmptyVariable(
          documentEditData?.originalData?.bookingLinkedDocumentId,
        )
      ) {
        id = documentEditData?.originalData?.bookingLinkedDocumentId;
        url = API_ENDPOINTS.linkedScannedDocuments + "/id/" + id;
      } else if (
        isNonEmptyVariable(
          documentEditData?.originalData?.visitorLogLinkedDocumentId,
        )
      ) {
        id = documentEditData?.originalData?.visitorLogLinkedDocumentId;
        url = API_ENDPOINTS.visitorLog.deleteLinkedDocs + id;
      }

      if (isNonEmptyVariable(id) && isNonEmptyVariable(url)) {
        dispatch(setDeleteAPis(url));
      }
    } else if (from == MODULES_LIST.FACILITY_LOG) {
      if (
        isNonEmptyVariable(
          documentEditData?.originalData?.commentLogLinkedDocumentID,
        )
      ) {
        let url =
          API_ENDPOINTS.facilityLog.deleteLinkedDocuments +
          documentEditData?.originalData?.commentLogLinkedDocumentID;
        api.delete(url).then((data) => {
          //  onSave([...docItemsCopy])
        });
      }
      onSave([...docItemsCopy]);
      setFacilityLogDocs([...docItemsCopy]);
    } else if (from == MODULES_LIST.JAIL_INCIDENTS) {
      dispatch(
        setJailIncidentStore({
          [docKey]: docItemsCopy,
        }),
      );
    } else handleCancel();
  };

  const onEditClick = () => {
    setIsModalShown(true);
    setIsEdit(true);
  };

  useEffect(() => {
    console.log({ docItems });
    let list = docItems?.map((di) => {
      return {
        originalData: di,
        documentType: di?.documents?.[0]?.documentType,
        documentName: di?.documents?.[0]?.documentName,
        documentDate: di?.documents?.[0]?.documentDate,
        author: di?.documents?.[0]?.author,
        comments: di?.documents?.[0]?.comments,
        documentPath: di?.documents?.[0]?.documentPath,
        // imageType: di?.documents?.[0]?.imageType,
      };
    });
    if (isNonEmptyVariable(list)) {
      setDocItemsList([...list]);
    }
    console.log({ list });
  }, [docItems]);

  return (
    <>
      <InmateDetailsTableContainer>
        <TableHeader>
          <h6></h6>
          <Flex gap={2}>
            <Button
              color="primary"
              type="primary"
              className="add-btn"
              onClick={onAddClick}
              icon={<PlusOutlined />}
              disabled={
                !bookingsFieldsEnabled ||
                !hasCheckSecurity(
                  Security_Types.functionality,
                  Entity_types.subModule,
                  LABELS_CAPITAL.ADD,
                  MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                  SUB_MODULES_LIST_WITH_ID.Arrest_Report,
                )
              }
            >
              Add Link
            </Button>
            <Button
              color="primary"
              type="primary"
              className="add-btn"
              onClick={onEditClick}
              icon={<EditOutlined />}
              disabled={
                from == MODULES_LIST.FACILITY_LOG
                  ? documentEditData === null
                  : documentEditData === null ||
                    !hasCheckSecurity(
                      Security_Types.functionality,
                      Entity_types.subModule,
                      LABELS_CAPITAL.VIEW,
                      MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                      SUB_MODULES_LIST_WITH_ID.Arrest_Report,
                    )
              }
            >
              Details
            </Button>
            <Popconfirm
              title="Delete the document"
              description="Are you sure to delete this document?"
              onConfirm={onDeleteClick}
              onCancel={() => {}}
              okText="Yes"
              cancelText="No"
            >
              <Button
                color="primary"
                type="primary"
                className="add-btn"
                icon={<DeleteOutlined />}
                disabled={
                  from == MODULES_LIST.FACILITY_LOG
                    ? documentEditData === null || !bookingsFieldsEnabled
                    : documentEditData === null ||
                      !bookingsFieldsEnabled ||
                      !hasCheckSecurity(
                        Security_Types.functionality,
                        Entity_types.subModule,
                        LABELS_CAPITAL.DELETE,
                        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                        SUB_MODULES_LIST_WITH_ID.Arrest_Report,
                      )
                }
              >
                {from == MODULES_LIST.JAIL_INCIDENTS ? "Break Link" : "Delete"}
              </Button>
            </Popconfirm>
            {/* <Button
                color="primary"
                type="primary"
                disabled={true}
                >
                Display Document
              </Button>
              <Button
                color="primary"
                type="primary"
                disabled={true}
                >
                Sign PDF
              </Button> */}
            <Button
              color="primary"
              type="primary"
              className="add-btn"
              onClick={handleCancel}
              icon={<StopOutlined />}
              disabled={ documentEditData === null }
            >
              Cancel
            </Button>
          </Flex>
        </TableHeader>
        {hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.subModule,
          LABELS_CAPITAL.VIEW,
          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
          SUB_MODULES_LIST_WITH_ID.Arrest_Report,
        ) && (
          <Table
            headers={DocsTableHeaders}
            data={
              docItems?.map((di) => {
                return {
                  originalData: di,
                  documentType:
                    di?.documents?.[0]?.documentType ||
                    di?.photos?.[0]?.documentType,
                  documentName:
                    di?.documents?.[0]?.documentName ||
                    di?.photos?.[0]?.documentName,
                  documentDate:
                    di?.documents?.[0]?.documentDate ||
                    di?.photos?.[0]?.documentDate,
                  author: di?.documents?.[0]?.author || di?.photos?.[0]?.author,
                  comments:
                    di?.documents?.[0]?.comments || di?.photos?.[0]?.comments,
                  documentPath: di?.documents?.[0]?.documentPath,
                  description:
                    di?.documents?.[0]?.description ||
                    di?.photos?.[0]?.description,
                  fullSizePath: di?.photos?.[0]?.fullSizePath,
                  // imageType: di?.documents?.[0]?.imageType,
                };
              }) || []
            }
            onRowClick={onRowFileClick}
            onRowDoubleClick={(data) => {
              onRowFileClick(data);
              onEditClick();
            }}
            selected={documentEditData === null}
          />
        )}
      </InmateDetailsTableContainer>

      <DocsModal
        show={isModalShown}
        ref={innerFormRef}
        document={documentEditData}
        handleCancel={handleCancel}
        handleSubmit={handleSubmit}
        isLinkedDocs={isLinkedDocs}
        isEdit={isEdit}
        setIsEdit={setIsEdit}
        bookingsFieldsEnabled={bookingsFieldsEnabled}
        from={from}
      />

      {isConfirmModal && (
        <Modal
          header="Linked Document or Scanned Photo?"
          size="md"
          designPattern="ant"
          show={isConfirmModal}
          footerActions={[
            <Button
              key="submit"
              type="primary"
              onClick={() => handleLinkedDoc(true)}
            >
              Yes
            </Button>,
            <Button key="back" onClick={() => handleLinkedDoc(false)}>
              No
            </Button>,
          ]}
        >
          <p>Is this a Linked Document?</p>
        </Modal>
      )}
    </>
  );
};

export default Docs;
